import HomeHeroSlice from "./HomeHeroSlice";
import BodycontentSlice from "./BodycontentSlice";
import ColumsSlice from "./ColumsSlice";
import LinkSlice from "./LinkSlice";
import SecondaryheroSlice from "./SecondaryheroSlice";
import FaqSlice from "./FaqSlice";
import VideoCallOutSlice from "./VideoCallOutSlice";
import DualColumnContentSlice from "./DualColumnContentSlice";
import ProcessimageSlice from "./ProcessimageSlice";
import HelparticleheadingSlice from "./HelparticleheadingSlice";

export const SLICE_COMPONENTS = {
  home_hero: HomeHeroSlice,
  bodycontent: BodycontentSlice,
  colums: ColumsSlice,
  link: LinkSlice,
  secondaryhero: SecondaryheroSlice,
  faq: FaqSlice,
  video_call_out: VideoCallOutSlice,
  dual_column_content: DualColumnContentSlice,
  processimage: ProcessimageSlice,
  helparticleheading: HelparticleheadingSlice,
};
